import * as React from 'react';
import { Box } from '@mui/material';
import useFetchCustodianDetails from '../../hooks/Locations/useFetchCustodianDetails';
import { useParams } from 'react-router';
import CustodianDetailsHeader from './Components/CustodianDetailsHeader';
import { custodianDetailsContainer } from './CustodianDetailsStyles';
import ComponentLoader from '../../common/ComponentLoader/componentLoader';
import MainInformationTab from './Components/MainInformationTab';
import CustodianDetailsViewModel from '../../Models/custodian/custodian-details-viewmodel';
import { useState } from 'react';

export default function CustodianDetails() {
  const { id } = useParams();
  const { custodian, isLoading } =
    useFetchCustodianDetails(id ?? '');
  const phoneTypeId = 1;

  const [isVisibleEdit, setIsVisibleEdit] = useState<boolean>(true);

  const handleCustodianUpdate = (
    updatedCustodian: CustodianDetailsViewModel,
  ) => {
    custodian.name = updatedCustodian.name;
    custodian.portalUrls = updatedCustodian.portalUrls;
    custodian.externalSourceMappings = updatedCustodian.externalSourceMappings;
    custodian.address = updatedCustodian.address;
    custodian.phoneNumbers = updatedCustodian.phoneNumbers;
  };

  return (
    <ComponentLoader isOpen={isLoading}>
      <Box sx={custodianDetailsContainer}>
        <Box>
          <CustodianDetailsHeader
            headerInfo={{
              address: custodian.address?.addressDetails ?? '-',
              creationDate: new Date(custodian.creationDate),
              phone: custodian.phoneNumbers?.find((x) => x.isPrimary === true)
                ?.phoneNumber ??
                custodian.phoneNumbers?.find(
                  (x) => x.phoneTypeId === phoneTypeId
                )?.phoneNumber ??
                '-',
              name: custodian.name,
            }} isVisibleEdit={isVisibleEdit}
            setIsVisibleEdit={setIsVisibleEdit} />
        </Box>
        <Box>
          <MainInformationTab
          isVisibleEdit={isVisibleEdit}
          setIsVisibleEdit={setIsVisibleEdit}
            custodian={custodian}
            onCustodianUpdate={handleCustodianUpdate}
          ></MainInformationTab>
        </Box>
      </Box>
    </ComponentLoader>
  );
}
